// @flow

import React from 'react';
import styled from 'styled-components';
import type { Props } from './types';
import type { Theme } from '../../../types';

const StyledInput = styled<any, Theme>('input')`
  cursor: inherit;
  height: 100%;
  left: 0;
  margin: 0;
  opacity: 0;
  padding: 0;
  position: absolute;
  top: 0;
  width: 100%;
`;

export default ({
  onChange, name, value, ...rest
}: Props) => (
  <StyledInput
    type="hidden"
    value={value}
    onChange={(e: SyntheticInputEvent<HTMLInputElement>) => onChange(e)}
    name={name}
    {...rest}
  />
);
